import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import EmailCampaignMessageAppResource from "./EmailCampaignMessageAppResource";

export const HOME_PURCHASE_HUBS_101_HOMEBUYER_JOINS = '49387211-c59c-471b-bfce-770bf2f6a4d5';
export const HOME_SALE_HUBS_101_HOMEOWNER_JOINS = '7656dab1-899c-44fd-9f38-ab9c826692c7';
export const HOME_BUYING_101 = 'df7f330a-9b81-47e4-a40f-5b457ebdc42c';
export const CLAIM_YOUR_HOME_OWNERSHIP_HUB = '7ebe661b-5776-4f57-9554-90f1ccb3a1fc';
export const GET_STARTED_WITH_YOUR_HOME_OWNERSHIP_HUB = '979e7319-1065-4be2-b1ef-b53d96b51813';
export const HOME_OWNERSHIP_HUB_INVITATION = 'a952c888-9ec5-4402-a161-43b45a50342d';
export const INTRODUCING_MILESTONES = 'e3462d9c-9cd1-4767-ba0d-5c79ed12aa7d';
export const ONBOARDING_SET_UP_PROFILE = '85a57cf1-51c6-43f1-82a0-46f0dda5cdfa';
export const ONBOARDING_CREATE_FIRST_HUB = 'a98d3f11-d89a-4b64-9512-ea0bf13dab30';
export const ONBOARDING_IMPORT_CONTACTS = '5f81aece-ecee-4fc1-a3ba-67c4e6f16866';
export const ONBOARDING_INVITE_HOMEOWNERS = '5b8ee608-3bd2-4aff-9c7c-774353bcc1f9';
export const ONBOARDING_RECOMMEND_SERVICE_PROS = '35b34d7b-e7fb-4984-ab84-235bab0a2a87';
export const ALL_HUBS_INVITATION_HO_PRO_ROLES = 'c7686050-ca0a-40c0-88c9-fa084389499f';
export const HOMEOWNER_ENGAGEMENT_BUILD_WEALTH = 'db0c8d51-0056-45b5-b160-19415fa873b1';
export const HOMEOWNER_ONBOARDING = 'a9311b3f-8116-438c-848c-95c28d58c12a';
export const GET_HOME_SERVICES = 'ad002695-94e5-4666-93d7-ad82f70cf0a2';

export const USER_ENGAGED = '64629152-48e7-4cca-93fc-0ac766d18d16';



export const ALL_CAMPAIGNS = [
    HOME_PURCHASE_HUBS_101_HOMEBUYER_JOINS,
    HOME_SALE_HUBS_101_HOMEOWNER_JOINS,
    HOME_BUYING_101,
    CLAIM_YOUR_HOME_OWNERSHIP_HUB,
    USER_ENGAGED,
    GET_STARTED_WITH_YOUR_HOME_OWNERSHIP_HUB,
    HOME_OWNERSHIP_HUB_INVITATION,
    INTRODUCING_MILESTONES,
    ONBOARDING_SET_UP_PROFILE,
    ONBOARDING_CREATE_FIRST_HUB,
    ONBOARDING_IMPORT_CONTACTS,
    ONBOARDING_INVITE_HOMEOWNERS,
    ONBOARDING_RECOMMEND_SERVICE_PROS,
    ALL_HUBS_INVITATION_HO_PRO_ROLES,
    HOMEOWNER_ENGAGEMENT_BUILD_WEALTH,
];

class EmailCampaignAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'email-campaign';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'emails/campaigns';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'title',
            'isActive',
            'isQuickSend',
            'groupId',
            'meta',
            'messages',
            'disabledAt',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            messages: EmailCampaignMessageAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            title: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            slug: {
                type: 'string',
                presence: true,
            },
            groupId: {
                type: 'string',
            },
            isActive: {
                type: 'boolean',
            },
            isQuickSend: {
                type: 'boolean',
            },
            meta: {},
        };
    }

}

export default EmailCampaignAppResource;
